import { useUserInfoStore } from "@/stores/userInfoStore";
// [0,0]  第一个是平台的权限，第二个值代表当前用户的权限   0：代表没有权限，1：可读权限，代表查询权限，2：代表可写，代表操作权限

//自定义指令根据后端返回值判断元素显示状态
const pulicEl = (el, binding, vnode) => {
	const { userInfo } = useUserInfoStore();
	let permissions = userInfo.permissionsV2 || {}; //v2字段
	let permissionRole = userInfo.permissionDeniedStyle; //permissionDeniedStyle权限
	if (!permissions) return false; //接口不返回不进行下面判断
	if (el.getAttribute("nopermission") == "true") return false;
	const type = el.getAttribute("permissionInfo"); //获取el自定义属性
	const value = permissions[type] || [0, 0]; // V2字段没有值全为0,0  -->没有任何权限
	// 没有任何权限，隐藏还是禁用根据接口返回的“permissionDeniedStyle”字段:0禁用，1隐藏
	if (value[1] === 0) {
		if (value[0] === 0 && permissionRole === 0) {
			el.disabled = true;
			if (!vnode.el.classList.contains("is-disabled")) vnode.el.classList.add("is-disabled");
		} else {
			el.style.display = "none";
		}
	}
	// 只有“读”权限
  // 菜单权限[2,1] 同 [2,2] 要展示
	if (value[1] === 1) {
    // console.log(vnode,'----',vnode.el.className,'dfg',vnode.props.class,vnode?.el)
    if(!(vnode.props.class.includes("el-menu-item"))){
      el.disabled = true;
		  if (!vnode.el.classList.contains("is-disabled")) vnode.el.classList.add("is-disabled");
    }
		
	}
};

// 用于v-if是否加载某个板块
const checkTabs = type => {
	const { userInfo } = useUserInfoStore();
	let permissions = userInfo.permissionsV2 || {}; //v2字段
	let permissionRole = userInfo.permissionDeniedStyle; //permissionDeniedStyle权限
	const value = permissions[type] || [0, 0]; // V2字段没有值全为0,0  -->没有任何权限
	if (value[1] === 0) {
		if (value[0] === 0 && permissionRole == 0) {
			return true;
		}
		return false;
	}
	return true;
};

export { pulicEl, checkTabs };
